module.exports = __webpack_public_path__ + "img/blue-bg.47a30c38.png";